import $ from "jquery";
import AOS from "aos";
import "slick-carousel";
import "./modules/header";
import "./modules/menu";
import "./modules/video-lazy-load";

$(document).ready(() => {
  AOS.init({ once: true, disable: "mobile" });
});

window.addEventListener("load", function () {
  window.dispatchEvent(new Event("resize"));
  var tag = document.createElement("script");
  tag.setAttribute("async", "async");
  tag.src = "//js.hsforms.net/forms/embed/v2.js";
  document.getElementsByTagName("footer")[0].appendChild(tag);
});
